import dayjs from "dayjs";
import { toLocaleString3 } from "helpers/formated";

export const parsePurchaseSupplier = (data: any[]): any[] => {
  const res = [];

  for (const item of data) {
    res.push({
      "pedido-id": item.documentId,
      "pedido-color": item.statusDeliveryDate,
      "pedido-centro": item.storeId + " - " + item.storeDescription,
      "pedido-status": item.statusScheduling,
      "pedido-numero": item.documentId,

      "quantidade-total": toLocaleString3(item.orderedQuantity),
      "quantidade-entregue":
        item.receivedQuantity > 0 ? toLocaleString3(item.receivedQuantity) : 0,
      "quantidade-pendente":
        item.quantityToSupply > 0 ? toLocaleString3(item.quantityToSupply) : 0,
      "quantidade-agendada":
        item.quantityScheduled > 0
          ? toLocaleString3(item.quantityScheduled)
          : 0,
      "quantidade-pedente-agendada":
        item.quantityPendingScheduling > 0
          ? toLocaleString3(item.quantityPendingScheduling)
          : 0,
      "data-prevista": dayjs(item.expectedDeliveryDate).format("DD/MM/YYYY "),
    });
  }

  return res;
};
